// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_tiE","cls2":"SimplePaperPodcast-cls2_czu SimplePaperPodcast-cls1_tiE"};